// extracted by mini-css-extract-plugin
export default {"container":"pl-z","blurb":"ql-z","links":"rl-z"};